export const isDevMode = process.env.NODE_ENV === "development";
